import React, { useState } from 'react';
import { ViewState } from '../types';

interface NavbarProps {
  currentView: ViewState;
  setView: (view: ViewState) => void;
  eventName: string;
}

export const Navbar: React.FC<NavbarProps> = ({ currentView, setView, eventName }) => {
  const [copied, setCopied] = useState(false);

  const handleShare = async () => {
    const currentUrl = window.location.href;
    
    // Check if we are in a temporary environment
    if (currentUrl.startsWith('blob:') || currentUrl.includes('localhost') || currentUrl.includes('127.0.0.1')) {
      if (!confirm("Note: This is a temporary preview link. Once you host your site on Vercel or GitHub, this button will share your permanent link. Copy this temporary link anyway?")) {
        return;
      }
    }

    if (navigator.share) {
      try {
        await navigator.share({
          title: "SANGHARSH '26 - Registration",
          text: `Register your college for ${eventName}!`,
          url: currentUrl,
        });
      } catch (err) {
        console.log('Share canceled or failed', err);
      }
    } else {
      try {
        await navigator.clipboard.writeText(currentUrl);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      } catch (err) {
        alert("Could not copy link automatically. Please copy the URL from your address bar.");
      }
    }
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 glass border-b border-gold/20">
      <div className="max-w-7xl mx-auto px-4 h-20 flex items-center justify-between">
        <div 
          className="flex items-center gap-3 cursor-pointer group"
          onClick={() => setView('HOME')}
        >
          <div className="flex flex-col">
            <span className="text-xl font-stencil tracking-tighter text-white leading-none">SANGHARSH</span>
            <span className="text-[10px] font-bold text-gold tracking-[0.2em]">ARSD NCC</span>
          </div>
        </div>
        
        <div className="hidden md:flex items-center space-x-8 text-sm font-medium">
          <button 
            onClick={() => setView('HOME')}
            className={`${currentView === 'HOME' ? 'text-gold' : 'text-gray-400'} hover:text-gold transition-colors uppercase tracking-widest font-bold text-[10px]`}
          >
            Home
          </button>
          <button 
            onClick={() => setView('INSTRUCTIONS')}
            className={`${currentView === 'INSTRUCTIONS' ? 'text-gold' : 'text-gray-400'} hover:text-gold transition-colors uppercase tracking-widest font-bold text-[10px]`}
          >
            Instructions
          </button>
          <button 
            onClick={handleShare}
            className="text-gray-400 hover:text-gold transition-colors uppercase tracking-widest font-bold text-[10px] flex items-center gap-2"
          >
            {copied ? 'LINK COPIED!' : 'SHARE SITE'}
            {!copied && (
              <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z" />
              </svg>
            )}
          </button>
        </div>

        <button 
          onClick={() => setView('REGISTER')}
          className="bg-red-900 border border-gold/30 hover:bg-red-800 text-white px-6 py-2 rounded-sm font-black text-xs transition-all transform hover:scale-105 active:scale-95 shadow-lg shadow-red-900/20 tracking-widest"
        >
          REGISTER NOW
        </button>
      </div>
    </nav>
  );
};